// test595
(595 && 0);
